import React, { useContext, useEffect, useState } from "react";
import { Container, Button, Form, InputGroup } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { ValidationMessage } from "../../utils/constants/validationMessage";
import { regex } from "../../utils/constants/regexVariables";
import { ErrorMessage } from "@hookform/error-message";
import { Link, useNavigate } from "react-router-dom";
import AuthContext from "../../hooks/context/AuthContext";
import { Loader } from "lucide-react";
import { decryptData, removeMultiSpace } from "../../helper/helper";

const Login = () => {
  let { handleLogin, loading } = useContext(AuthContext);
  const navigate = useNavigate();
  const Token = localStorage.getItem("token");
  const userType = localStorage.getItem("user-type");

  // HOOK FORM
  const {
    register,
    setValue,
    clearErrors,
    watch,
    reset,
    formState: { errors },
    handleSubmit,
  } = useForm();

  /// ALL STATE
  const [showPassword, setShowPassword] = useState(false);
  const [rememberCheck, setRememberCheck] = useState(
    typeof window !== "undefined" &&
      window?.localStorage.getItem("rememberMe") === "true"
  );

  useEffect(() => {
    if (Token) {
      if (userType == "member") {
        navigate("/member-info");
      } else {
        navigate("/dashboard");
      }
    }

    // Load remembered email and password
    if (rememberCheck) {
      setValue("email", localStorage.getItem("email") || "");
      setValue("password", localStorage.getItem("password") || "");
    }
  }, [Token, rememberCheck, setValue]);

  const onSubmit = (data) => {
    const payloadData = { ...data };
    const result = {
      email: data?.email?.trim() || "",
      password: data?.password?.trim() || "",
    };
    handleSetCheck(result);
    try {
      handleLogin(payloadData);
    } catch (err) {
      console.error("Error", err);
    }
  };

  const handelRememberCheck = (e) => {
    const isChecked = e.target.checked;
    setRememberCheck(isChecked);
    if (typeof window !== "undefined") {
      localStorage.setItem("rememberMe", isChecked);
      if (!isChecked) {
        localStorage.removeItem("email");
        localStorage.removeItem("password");
      }
    }
  };

  const handleSetCheck = (data) => {
    if (rememberCheck && typeof window !== "undefined") {
      localStorage.setItem("email", data.email);
      localStorage.setItem("password", data.password);
    } else {
      localStorage.removeItem("email");
      localStorage.removeItem("password");
    }
  };

  return (
    <section className="login-sec for-mobile">
      <Container>
        <Form onSubmit={handleSubmit(onSubmit)} noValidate autoComplete="off">
          <div className="wrapper">
            <div className="common-heading text-center mb-4">
              <h2>Sign In</h2>
            </div>
            <Form.Group className="mb-4">
              <Form.Control
                type="email"
                placeholder="Email"
                name="email"
                {...register("email", {
                  required: ValidationMessage.EMAIL_REQUIRED,
                  pattern: {
                    value: regex.regEmail,
                    message: ValidationMessage.ENTER_VALID_EMAIL,
                  },
                })}
                onInput={removeMultiSpace}
              />

              <ErrorMessage
                errors={errors}
                name="email"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <InputGroup>
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  placeholder="Password"
                  name="password"
                  {...register("password", {
                    required: ValidationMessage.PASSWORD_REQUIRED,
                    pattern: {
                      value: regex.regPassword,
                      message: ValidationMessage.PASSWORD_VALID,
                    },
                  })}
                />
                <Button
                  variant="outline-secondary"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="bi bi-eye"></i>
                  ) : (
                    <i className="bi bi-eye-slash"></i>
                  )}
                </Button>
              </InputGroup>
              <ErrorMessage
                errors={errors}
                name="password"
                render={({ message }) => (
                  <p className="error-message text-start py-2 px-1 text-danger">
                    {message}
                  </p>
                )}
              />
            </Form.Group>
            <div>
              <div className="checkbox_div">
                <input
                  type="checkbox"
                  id="checkbox1"
                  checked={rememberCheck}
                  onChange={(e) => handelRememberCheck(e)}
                  style={{ transform: "scale(1.5)", marginRight: "5px" }}
                />
                <label className="custom-label form-check-label ml-2">
                  Remember me
                </label>
              </div>
              <div className="text-end d-flex justify-content-end align-item-end w-100">
                <Link
                  className="forgot-password mb-3 d-block"
                  to="/forgot-password"
                  style={{ width: "113px" }}
                >
                  Forgot Password?
                </Link>
              </div>
            </div>
            <Button
              type="submit"
              className="themeht-btn btn w-100 py-2 mt-3"
              disabled={loading}
              style={
                loading ? { cursor: "not-allowed" } : { cursor: "pointer" }
              }
            >
              <span className="d-flex fs-6 justify-content-center align-items-center">
                Sign In
                {loading && (
                  <Loader
                    style={{
                      marginLeft: "20px",
                    }}
                    className="loader"
                  />
                )}
              </span>
            </Button>

            <div className="dont-have-account pt-4 text-center">
              <h4>
                Don't have an account? <a href="/registration">Sign Up</a>
              </h4>
            </div>
          </div>
        </Form>
      </Container>
    </section>
  );
};

export default Login;
